export const salesPipelineData = [
    {
        name: "Leads",
        revenue: "74,569",
        deals: 57,
        data: [20, 30, 40, 50, 46, 42, 38, 34, 30, 28, 26, 25],
        chartColors: ["#E9EDF7", "#E9EDF7", "#E9EDF7", "#3454D1", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7"]
    },

    {
        name: "Proposal",
        revenue: "35,285",
        deals: 46,
        data: [28, 30, 32, 35, 38, 41, 44, 47, 50, 40, 30, 20],
        chartColors: ["#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#3454D1", "#E9EDF7", "#E9EDF7", "#E9EDF7"]
    },
    {
        name: "Contract",
        revenue: "24,569",
        deals: 34,
        data: [10, 20, 30, 40, 50, 60, 55, 50, 45, 40, 35, 30],
        chartColors: ["#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#3454D1", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7"]
    },
    {
        name: "Project",
        revenue: "53,853",
        deals: 42,
        data: [10, 20, 30, 40, 50, 60, 65, 50, 45, 40, 35, 30],
        chartColors: ["#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#3454D1", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7", "#E9EDF7"]
    },

]